/**
 * Asistente IA (Fase 1, sólo lectura). Ver docs/DISENO_ASISTENTE_IA.md.
 *
 * Sólo para el personal del comité: el portal del socio no tiene asistente.
 */
import { apiRequest } from "../../lib/api";

export interface EstadoAsistente {
  habilitado: boolean;
  tope_usd_mes: string;
  gasto_mes_usd: string;
  preguntas_hoy: number;
  max_preguntas_dia: number;
  modelo: string;
}

export interface Conversacion {
  id: number;
  titulo: string;
  created_at: string;
  updated_at: string;
}

export interface Mensaje {
  rol: "user" | "assistant";
  texto: string;
  herramientas: string[];
  creado: string;
}

export interface Respuesta {
  conversacion_id: number;
  texto: string;
  herramientas_usadas: string[];
  completa: boolean;
}

export function fetchEstado(): Promise<EstadoAsistente> {
  return apiRequest<EstadoAsistente>("/api/v1/asistente/estado");
}

export function fetchConversaciones(): Promise<Conversacion[]> {
  return apiRequest<Conversacion[]>("/api/v1/asistente/conversaciones");
}

export function fetchMensajes(conversacionId: number): Promise<Mensaje[]> {
  return apiRequest<Mensaje[]>(`/api/v1/asistente/conversaciones/${conversacionId}/mensajes`);
}

export function preguntar(texto: string, conversacionId: number | null): Promise<Respuesta> {
  return apiRequest<Respuesta>("/api/v1/asistente/preguntar", {
    method: "POST",
    body: { texto, conversacion_id: conversacionId },
  });
}

/** Nombre legible de cada herramienta, para mostrar qué consultó. */
export const ETIQUETA_HERRAMIENTA: Record<string, string> = {
  buscar_socio: "Buscó al socio",
  estado_cuenta_socio: "Revisó la cuenta corriente",
  historial_consumo: "Revisó el historial de consumo",
  explicar_boleta: "Revisó la boleta",
  listar_deudores: "Revisó los deudores",
  resumen_periodo: "Revisó el resumen del mes",
  consumos_anomalos: "Revisó consumos anómalos",
  analisis_consumo: "Revisó el análisis de consumo",
  consultar_tarifa: "Revisó las tarifas",
  listar_atenciones: "Revisó las atenciones",
  listar_ordenes_trabajo: "Revisó las órdenes de trabajo",
  listar_cortes: "Revisó los cortes",
};

// ── Console (superadmin) ────────────────────────────────────────────────

export interface TopeAsistente {
  empresa_id: number;
  tope_usd_mes: string;
  gasto_mes_usd: string;
}

export function fetchTopeAsistente(empresaId: number): Promise<TopeAsistente> {
  return apiRequest<TopeAsistente>(`/api/v1/superadmin/empresas/${empresaId}/asistente`);
}

export function putTopeAsistente(empresaId: number, tope: string): Promise<TopeAsistente> {
  return apiRequest<TopeAsistente>(`/api/v1/superadmin/empresas/${empresaId}/asistente`, {
    method: "PUT",
    body: { tope_usd_mes: tope },
  });
}
